var _defs, _defs2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 438,
    height: 347,
    viewBox: "0 0 438 347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.8 21.5a14 14 0 00-.6 2c-.4 2.4.3 5 1.7 6.7a7.2 7.2 0 006 2.5c-6 1-9-2-13-6.7l-4 11.4c-.4.9-.7 1.8-.7 2.8.1 1.9 1.5 3.3 2.9 4.5l-4.8-.5c.1 3.9-1.4 7.7-2.8 11.4A20.3 20.3 0 001 67c.7 3 2.7 5.3 4.8 7.5 1 .9 1.9 1.8 3 2.5a5.3 5.3 0 006 0c1-.6 2.2-1.3 3.5-1.6 2.7-.8 1.6 5.6 4.1 6.6 2.6 1 5.4.5 8.2.1 2-.3 4.2-.6 5.9-1.9 2-1.5 3-4 4-6.3l3.2-7.5c.7-1.7 1.5-3.5 1.2-5.3-.2-1.9-1.9-3.5-3.6-3l4.4-1.7 1.1-15.3c0-1 .1-2-.3-2.7-.8-1.5-2.8-1.5-4.5-1.3-1.6.1-3.6.1-4.4-1.4 2.7-.7 5.5-1.6 7.1-4 1-1.5 1.4-3.4 1.5-5.3a38 38 0 00-8.7-25L35.7.3a37 37 0 00-18 21.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M19.8 21.5a14 14 0 00-.6 2c-.4 2.4.3 5 1.7 6.7a7.2 7.2 0 006 2.5c-6 1-9-2-13-6.7l-4 11.4c-.4.9-.7 1.8-.7 2.8.1 1.9 1.5 3.3 2.9 4.5l-4.8-.5c.1 3.9-4.4 8.5-5.8 12.2-1.3 3.7-1.1 7-.2 10.8.7 3 4.3 5.2 6.4 7.4 1 .9 1.9 1.8 3 2.5a5.3 5.3 0 006 0c1-.6 2.2-1.3 3.5-1.6h.7L37.7.2a37 37 0 00-18 21.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M84.3.6c-2.2.5-4 1.7-5.7 3.1-4.9 4-8.4 9.6-10 15.7-.1.9-.7 1.6-1.6 1.8-1.4.4-2.2-1.1-2-2.3 0-1 .6-2 1-3 1.4-4.7-3.9-10.8-9.7-6.5-1 .8-1.9 1.9-2.2 3.2-.4 1.4-.4 2.7-.4 4.2 0 2 .3 2.3-1.2 3.6-.9.8-2.2 1.1-3.2.6-1.8-1-2-1.3-2.3-3.2a7.5 7.5 0 00-9-5.4c-4.3 1.2-6.7 6.6-4.4 10.4.5.8.7 1.8.4 2.7-.5 1.8-2.4 1.6-3.5.6-.7-.7-1-1.7-1.6-2.5-1.8-3.4-5.2-6-9-6s-9.7 5-11.9 8c-4.2 6.2-6.3 9.1-7.4 13-.8 2.8.9 10.7 2.7 12 2 1.5 21 4.4 32.6 5.8 2.4.3 7 0 8.9-1.7 1.7-1.5 2.3-4.5.8-6.4-1.4-1.7-4-2.9-2.6-4.3.8-.9 2.5.2 3.3 1 2.5 2 2 2.3 4.5 4.5 3 2.6 7.7 4 10.6.5.8-1.1 1.3-2.5 1.3-4 0-1.9-.6-3.6-1.6-5.2-.4-.7.4-1.5 1.1-1l7.7 4.1c2.5 1.2 5.1 2.3 7.9 2.1 2.7-.2 5.5-2 5.8-4.8.2-1.8-.8-3.6-2.3-4.8a9 9 0 00-5.2-1.6c-1 0-2 0-2.8-.2-.8-.3-1.6-1.1-1.6-2 0-1 1-1.7 2-1.8 1 0 2 .2 2.9.5 4.6 1.4 9.5 1.4 14 0 1.7-.4 3.4-1 4.6-2.2 1.2-1.2 2-3 1.6-4.6C96 22 93 20.8 90.4 21c-2.7.2-5.2 1.2-7.9 1.3-1.7 0-4-.7-3.7-2.7.2-1 .9-1.8 1.8-2.2 3.4-1.5 7.3-3 9.6-6 2-2.7 2.5-6.9.1-9.2A6.2 6.2 0 0085.9.5l-1.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M67 .2c-1 .6-2.4 1-3.7 1-2.4.4-5 .5-6.8 2-.7.7-1.2 1.6-2 2.2-.7.7-1.8 1-2.6.5-.6-.3-.7-1.2-.4-1.7.2-.4 0-.8-.4-1-2.7-.7-6.3 1.4-6 4.6.2.7.1 1.4-.2 2-1.5 3.2-4.2 1.1-4.2-.9 0-1 .5-2 1-3 .4-.4 0-1-.5-1.1-2.9-.2-5.9 2.7-4.9 5.7.3.8.4 1.6.2 2.3-.6 2.6-3.5 1.5-4-.2-.3-1-.1-2 .2-3 .2-.7-.4-1.5-1.1-1.4-1.3 0-2.5.3-3.6 1a5.4 5.4 0 00-2.5 4.4c0 1.2.5 2.3.8 3.5.3 1.3.5 2.9-.5 4-.5.7-1.4 1-2.2.6-1.3-.6-1.2-2.1-1-3.4l.6-5.3c0-.5-.5-1-1-.8-2.3.7-4.6 1.5-6.4 3-2 1.7-3.4 4.7-2.5 7.3.6 1.5 1.9 2.7 2.4 4.2.1.5.2 1 0 1.6-.2 1.5-2.3 1.8-3 .4-1-2-1.7-4.2-1.8-6.4 0-.6-.8-1-1.3-.5-1 .8-1.9 1.7-2.5 2.8-1 1.5-1.3 3.5-.5 5 1 2 3.6 2.7 4.2 5 .2 1-.2 2-1 2.3-1.5.7-2.7-.9-3.2-2.3-.3-1-.5-2-1-2.7a1 1 0 00-1.6-.1c-1 1-1.8 2.2-2.2 3.6-.6 2 0 4.6 2.4 5.2.6.1 1.2.4 1.6.9 1.7 1.7-.6 3.3-2.1 2.8a4 4 0 01-1.9-1.5.6.6 0 00-1 .3 30 30 0 002 15.3l.2 1.1c2.6-.6 6-1.2 7.5-3.2.2-.4.2-1-.2-1.3-.9-1-2.2-2.8-2.2-3.6.1-1.1 1-2.1 2-2.2 1.1 0 5 4.3 6 4.8 1.5.6 4.5-3 5.8-4.7a.9.9 0 00-.3-1.4c-2-.7-5-2.3-6.3-2.7-1-.2-2-.6-2.2-1.6 0-.8.4-1.4 1.1-1.7 1.3-.5 2.5.2 3.6.8 0 0 5.4 3.7 8 3.6 2.9-.1 4.2-.8 6.5-2.3.4-.3.6-.8.5-1.3a8.1 8.1 0 00-8.3-6.1c-1.4 0-3 .5-4-.6-1-.8-.9-2.2-.1-3.1 1.2-1.5 3.3-1.4 4.9-.5 1.3.7 2.3 1.8 3.3 3 1 1 2.1 2.2 3.5 2.7 2 1 4.5.4 6.4-.6 2-1.1 3.5-2.8 5-4.4.5-.4 1-1 .9-1.6-.1-.8-1-1.2-1.8-1.5l-8.4-2.5c-.7-.3-1.4-.5-2-.9-.9-.6-1.5-1.8-.7-2.9.4-.5 1-.8 1.7-.9 1.4-.2 2.6.6 3.8 1.3 3 2 5.6 4.7 9 5.7.5.2 2.6-1.4 3.4-2.3 3.6-3.9 4.8-5.4-.4-5.9l-4.5-1c-1.2-.2-2.5-.6-2.7-1.8-.2-.9.4-1.7 1.3-2 1.6-.7 3 .1 4.3 1 1.5.8 2.9 1.7 4.5 2.2 1.6.5 3.4.4 4.7-.5.7-.5 1.1-1.1 1.4-1.9.2-.8-.6-1.4-1.3-1-1 .4-2.4 0-3.6-.8-1-.6-1.3-2-.6-3 .2-.3.5-.6.9-.8 2.5-1.8 3.1 1.6 6.2 2.1 1.6.3 3.5-.6 4-2 .4-.7-.4-1.5-1.1-1.2-.6.3-1.3.2-1.7-.4-.4-.5-.5-1.3 0-1.9.4-.5 1-.8 1.6-1C65 6.3 67 4 68.3 1.4c.3-.6-.2-1.3-.8-1.3l-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M.3.8h92.2v72.5H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M2 2.7a6.4 6.4 0 00-2 4.5c0 3.6 2.8 6.5 6.4 6.6h.1A6.5 6.5 0 0013 7.4C13 4 10.2 1 6.6 1h-.1C4.8.9 3.2 1.5 2 2.7M6.4 12A4.6 4.6 0 012 7.3a4.6 4.6 0 014.6-4.5c2.6 0 4.7 2 4.6 4.6 0 1.2-.5 2.4-1.4 3.2-.8.8-2 1.3-3.2 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M.7 4.9C.6 7.4 2.6 9.5 5.3 9.7c2.6.1 4.9-1.8 5-4.3A4.7 4.7 0 005.5.6 4.7 4.7 0 00.7 4.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M3.5.1a3 3 0 00-3 3.2 3 3 0 003 3 3 3 0 003.1-3.1 3 3 0 00-3-3h-.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFCF44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "55.2%",
    x2: "43.3%",
    y1: "-4%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFCF44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFCF44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFCF44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFCF44"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M325 292.8h45.6V167.4h-45.7zm-199.4 9h236.2v-9H125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M116.9 221.8h208.8v-46H117zm0 54.3h208.8v-46H117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M325 221.8h7.8v-46H325zm0 54.3h7.8v-46H325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M110.8 167.4h214.1v-7.8H110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M325 167.4h52v-7.8h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M248.3 136h127V1h-127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M259 125.4h105.7V11.6H259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M323.5 80.8l20.3-9.3v-6l-20.3-9.3v7l12.3 5.3-12.3 5.3zm-13.1-27.3h-3.7l6.5 30h3.7zM300 73.8l-12.3-5.3 12.3-5.3v-7L280 65.6v5.9l20.2 9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M61.1 301.7h7V72.5h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M59.6 300.1l-.1-1s1.9-.4 3.3-2.9c1.8-3.2 3-10.1-2.2-24.6-7.8-22.3-3.1-40.3 6.2-76.2l5.4-21c7.1-28.7.5-46.4-4.8-60.7-4.2-11.1-7.4-19.9-3.2-30l.9.4c-4 9.7-.8 18.3 3.2 29.2 5.4 14.4 12 32.4 4.8 61.4l-5.3 21c-9.3 35.6-14 53.5-6.2 75.6 5.2 14.9 4 22 2 25.5-1.6 2.8-3.9 3.3-4 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M51.9 301.7h25.5l-7.1-4.2H59zm-37.7-200H115L104 17H25.2zm149.6 14h53.8l-7 44h-39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M199.7 115.3c-11.3-7.7-19.2-16.5-6.2-25.9 13-9.3 29.1-4.5 38.8 4.2 12.3 11 5.2 30.4 5.2 30.4s-26.6-1-37.8-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M203.6 63.5c-7.8.5-14.6-.7-12-9.5 2.6-8.9 11.6-12.4 19-12 9.5.7 13.2 12 13.2 12s-12.4 9-20.2 9.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(337 147.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M17.8 21.5a14 14 0 00-.6 2c-.4 2.4.3 5 1.7 6.7a7.2 7.2 0 006 2.5c-6 1-9-2-13-6.7l-4 11.4c-.4.9-.7 1.8-.7 2.8.1 1.9 1.5 3.3 2.9 4.5l-4.8-.5c.1 3.9-1.4 7.7-2.8 11.4A20.3 20.3 0 001 67c.7 3 2.7 5.3 4.8 7.5 1 .9 1.9 1.8 3 2.5a5.3 5.3 0 006 0c1-.6 2.2-1.3 3.5-1.6 2.7-.8 1.6 5.6 4.1 6.6 2.6 1 5.4.5 8.2.1 2-.3 4.2-.6 5.9-1.9 2-1.5 3-4 4-6.3l3.2-7.5c.7-1.7 1.5-3.5 1.2-5.3-.2-1.9-1.9-3.5-3.6-3l4.4-1.7 1.1-15.3c0-1 .1-2-.3-2.7-.8-1.5-2.8-1.5-4.5-1.3-1.6.1-3.6.1-4.4-1.4 2.7-.7 5.5-1.6 7.1-4 1-1.5 1.4-3.4 1.5-5.3a38 38 0 00-8.7-25L35.7.3a37 37 0 00-18 21.2",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335 147.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M19.8 21.5a14 14 0 00-.6 2c-.4 2.4.3 5 1.7 6.7a7.2 7.2 0 006 2.5c-6 1-9-2-13-6.7l-4 11.4c-.4.9-.7 1.8-.7 2.8.1 1.9 1.5 3.3 2.9 4.5l-4.8-.5c.1 3.9-4.4 8.5-5.8 12.2-1.3 3.7-1.1 7-.2 10.8.7 3 4.3 5.2 6.4 7.4 1 .9 1.9 1.8 3 2.5a5.3 5.3 0 006 0c1-.6 2.2-1.3 3.5-1.6h.7L37.7.2a37 37 0 00-18 21.2",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(333 277.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M84.3.6c-2.2.5-4 1.7-5.7 3.1-4.9 4-8.4 9.6-10 15.7-.1.9-.7 1.6-1.6 1.8-1.4.4-2.2-1.1-2-2.3 0-1 .6-2 1-3 1.4-4.7-3.9-10.8-9.7-6.5-1 .8-1.9 1.9-2.2 3.2-.4 1.4-.4 2.7-.4 4.2 0 2 .3 2.3-1.2 3.6-.9.8-2.2 1.1-3.2.6-1.8-1-2-1.3-2.3-3.2a7.5 7.5 0 00-9-5.4c-4.3 1.2-6.7 6.6-4.4 10.4.5.8.7 1.8.4 2.7-.5 1.8-2.4 1.6-3.5.6-.7-.7-1-1.7-1.6-2.5-1.8-3.4-5.2-6-9-6s-9.7 5-11.9 8c-4.2 6.2-6.3 9.1-7.4 13-.8 2.8.9 10.7 2.7 12 2 1.5 21 4.4 32.6 5.8 2.4.3 7 0 8.9-1.7 1.7-1.5 2.3-4.5.8-6.4-1.4-1.7-4-2.9-2.6-4.3.8-.9 2.5.2 3.3 1 2.5 2 2 2.3 4.5 4.5 3 2.6 7.7 4 10.6.5.8-1.1 1.3-2.5 1.3-4 0-1.9-.6-3.6-1.6-5.2-.4-.7.4-1.5 1.1-1l7.7 4.1c2.5 1.2 5.1 2.3 7.9 2.1 2.7-.2 5.5-2 5.8-4.8.2-1.8-.8-3.6-2.3-4.8a9 9 0 00-5.2-1.6c-1 0-2 0-2.8-.2-.8-.3-1.6-1.1-1.6-2 0-1 1-1.7 2-1.8 1 0 2 .2 2.9.5 4.6 1.4 9.5 1.4 14 0 1.7-.4 3.4-1 4.6-2.2 1.2-1.2 2-3 1.6-4.6C96 22 93 20.8 90.4 21c-2.7.2-5.2 1.2-7.9 1.3-1.7 0-4-.7-3.7-2.7.2-1 .9-1.8 1.8-2.2 3.4-1.5 7.3-3 9.6-6 2-2.7 2.5-6.9.1-9.2A6.2 6.2 0 0085.9.5l-1.6.1",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#619440",
    d: "M365.7 242.2c2-12.2 8.7-23.7 18.9-31.8 6.1-5 13.5-8.7 21.3-11 .2-6.7 6.1-12.8 12.9-13.3.1-.7.8-1.3 1.6-1.5.5-.1 1.2 0 1.5.4.5.7.7 1.4.7 2.1 0 .6-.8 1-1.4 1l-.5-.1a1.6 1.6 0 01-1.8-1c-3 .8-5.7 1.9-8 4a12 12 0 00-3.8 8.2l.2-.1h.4c1.2-2 3.6-3.7 5.4-4.8 1.9-1 4-2.1 6.2-2.3 0-.5.2-1 .5-1.3.3-.5 1.1-.6 1.6-.3l.1.1c.5.3 1 .9 1.1 1.3.2.6-.1 1.2-.7 1.4l-.7.3c-.5.2-1 0-1.4-.4l-.2-.4c-2.2.9-4.3 1.5-6.3 2.8-1.2.8-2.4 1.6-3.4 2.7l-.4.4c3.4-.7 7-1.1 10.4-1.2.1-.5.4-.8 1-1h.7c.2 0 .5 0 .7.2 1.2.8.6 2.5-.7 2.7-1 .1-1.6-.6-1.7-1.3-3.4.3-6.8.9-10.1 1.7l3.5.8c2.3.4 4.8.6 7 1.3l.3-.4c.2-.3.7-.4 1-.3h.2c1 .3 1.1 1.5.7 2.3-.3.5-1.1.8-1.6.3-.4-.3-.6-.7-.7-1.1-2.2-.1-4.6-.6-6.8-1l-4.2-.7.8.9a19 19 0 002.9 2.4c2 1.3 4 1.9 6 2.8 0-.6.6-1.1 1.2-1.2.5 0 .9.2 1.1.5l.5.8c.2.5 0 1-.4 1.4-.4.2-1.1.3-1.5 0l-.6-.7c-2.5-.1-5-1.5-7-2.9-1.6-1-3.6-2.5-4.6-4.3-.2.2-.3.1-.4 0v.3c.4 3.7 2.5 6.9 5.7 8.8a15 15 0 007.8 1.8c0-.4 0-.7.4-1 .6-.6 1.7-.5 2 .3.5.3.8.6.9 1 .3.7-.1 1.6-1 1.8-.9.2-1.7-.4-2-1.1-6.8 1.4-14-4.4-15-11v-.8a55 55 0 00-33.7 26.4 46.8 46.8 0 00-5.4 33c0 .2-.3.3-.4.1-2.2-6.7-2-11-.8-18"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349 219.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF4D",
    d: "M67 .2c-1 .6-2.4 1-3.7 1-2.4.4-5 .5-6.8 2-.7.7-1.2 1.6-2 2.2-.7.7-1.8 1-2.6.5-.6-.3-.7-1.2-.4-1.7.2-.4 0-.8-.4-1-2.7-.7-6.3 1.4-6 4.6.2.7.1 1.4-.2 2-1.5 3.2-4.2 1.1-4.2-.9 0-1 .5-2 1-3 .4-.4 0-1-.5-1.1-2.9-.2-5.9 2.7-4.9 5.7.3.8.4 1.6.2 2.3-.6 2.6-3.5 1.5-4-.2-.3-1-.1-2 .2-3 .2-.7-.4-1.5-1.1-1.4-1.3 0-2.5.3-3.6 1a5.4 5.4 0 00-2.5 4.4c0 1.2.5 2.3.8 3.5.3 1.3.5 2.9-.5 4-.5.7-1.4 1-2.2.6-1.3-.6-1.2-2.1-1-3.4l.6-5.3c0-.5-.5-1-1-.8-2.3.7-4.6 1.5-6.4 3-2 1.7-3.4 4.7-2.5 7.3.6 1.5 1.9 2.7 2.4 4.2.1.5.2 1 0 1.6-.2 1.5-2.3 1.8-3 .4-1-2-1.7-4.2-1.8-6.4 0-.6-.8-1-1.3-.5-1 .8-1.9 1.7-2.5 2.8-1 1.5-1.3 3.5-.5 5 1 2 3.6 2.7 4.2 5 .2 1-.2 2-1 2.3-1.5.7-2.7-.9-3.2-2.3-.3-1-.5-2-1-2.7a1 1 0 00-1.6-.1c-1 1-1.8 2.2-2.2 3.6-.6 2 0 4.6 2.4 5.2.6.1 1.2.4 1.6.9 1.7 1.7-.6 3.3-2.1 2.8a4 4 0 01-1.9-1.5.6.6 0 00-1 .3 30 30 0 002 15.3l.2 1.1c2.6-.6 6-1.2 7.5-3.2.2-.4.2-1-.2-1.3-.9-1-2.2-2.8-2.2-3.6.1-1.1 1-2.1 2-2.2 1.1 0 5 4.3 6 4.8 1.5.6 4.5-3 5.8-4.7a.9.9 0 00-.3-1.4c-2-.7-5-2.3-6.3-2.7-1-.2-2-.6-2.2-1.6 0-.8.4-1.4 1.1-1.7 1.3-.5 2.5.2 3.6.8 0 0 5.4 3.7 8 3.6 2.9-.1 4.2-.8 6.5-2.3.4-.3.6-.8.5-1.3a8.1 8.1 0 00-8.3-6.1c-1.4 0-3 .5-4-.6-1-.8-.9-2.2-.1-3.1 1.2-1.5 3.3-1.4 4.9-.5 1.3.7 2.3 1.8 3.3 3 1 1 2.1 2.2 3.5 2.7 2 1 4.5.4 6.4-.6 2-1.1 3.5-2.8 5-4.4.5-.4 1-1 .9-1.6-.1-.8-1-1.2-1.8-1.5l-8.4-2.5c-.7-.3-1.4-.5-2-.9-.9-.6-1.5-1.8-.7-2.9.4-.5 1-.8 1.7-.9 1.4-.2 2.6.6 3.8 1.3 3 2 5.6 4.7 9 5.7.5.2 2.6-1.4 3.4-2.3 3.6-3.9 4.8-5.4-.4-5.9l-4.5-1c-1.2-.2-2.5-.6-2.7-1.8-.2-.9.4-1.7 1.3-2 1.6-.7 3 .1 4.3 1 1.5.8 2.9 1.7 4.5 2.2 1.6.5 3.4.4 4.7-.5.7-.5 1.1-1.1 1.4-1.9.2-.8-.6-1.4-1.3-1-1 .4-2.4 0-3.6-.8-1-.6-1.3-2-.6-3 .2-.3.5-.6.9-.8 2.5-1.8 3.1 1.6 6.2 2.1 1.6.3 3.5-.6 4-2 .4-.7-.4-1.5-1.1-1.2-.6.3-1.3.2-1.7-.4-.4-.5-.5-1.3 0-1.9.4-.5 1-.8 1.6-1C65 6.3 67 4 68.3 1.4c.3-.6-.2-1.3-.8-1.3l-.4.1",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345 247.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#619440",
    d: "M.3 73.3C5.8 69.4 12.4 61.9 18 59.5c1.6-.7 4.5-1.3 6-2 1.4-.9 2.6-2.5 2.2-4.1-.3-1.7-2.6-3.6-2.6-3.6-1.6-1.2-.1-3.6 1.7-3l8.9 3.7c1.6.7 3.2 1.4 5 1.4 1.7 0 3.6-.8 4.3-2.4 1-2-.2-4.4-1.7-6-1.9-1.8-4.3-3.2-5.4-5.7a4.2 4.2 0 010-3.6c1.2-2 3.5-2 5.2-1.1 1.2.6 2.2 1.7 3.3 2.6 3 2.7 6.8 4.7 10.8 5.6 2.3.6 5 .9 7-.7 1-.8 1.7-2.2 1.5-3.5-.4-2.4-3-3.2-5-4.3H59c-2-1-.5-4 1.5-3.2 4.9 2 10 3.6 15 5 2.5.6 5.3 1.1 7.6-.4 1-.7 1.8-2 1.7-3.3-.1-2-1.8-2.8-3.4-3.5l-6-2.8c-1.2-.5-1-2.1.3-2.2l4.2-.5c3.2-.4 6.4-.7 9-2.4 2.6-1.7 4.4-5.2 3.2-8-.8-2-2.9-3.3-5-3.7-2.1-.3-4.3 0-6.4.6-5.8 1.7-11.1 4.6-16.5 7.3-1.6.8-4 1.3-4.8-.2-.6-1.2.2-2.6 1.3-3.4C62.5 11 65 10.8 65.6 8c.4-1.9 0-4-1.4-5.3-2-2-5.3-2.3-8-1.2-2.5 1-4.6 3.2-6 5.7C48.8 9.6 48 12.3 47 15c-.3.9-.7 1.8-1.4 2.5-.7.6-2 .8-2.7.2-.6-.6-.6-1.5-.5-2.3 0-1.5-.2-3-1-4.2-2.8-4.9-8.9-2.8-10 1.2a10 10 0 000 5c.5 1.8 1 3.4 1 5.2-.1 2-1 4-3 4.7-1.4.4-3-.2-3.5-1.6-.7-1.8 1-3.5 1.4-5.3.5-2.4-1.3-5-3.7-5.6-2.5-.6-5 .5-6.7 2.4a11 11 0 00-2.3 7c0 2.4.5 4.9 1 7.3.4 1.3.7 2.8 0 4-.6 1-1.8 1.4-2.7.7-.8-.5-.7-1.7-1.2-2.6-.9-1.7-3.6-1.4-4.9.1-1.2 1.5-1.4 3.6-1.4 5.5l-.8 18L.3 73.3z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#306B34",
    d: "M4.4 59.8c.7-1 8-15.7 34.7-30.2 23.6-12.8 53.6-16.7 53-18.2-.8-2-2.9-3.2-5-3.6-2.1-.3-4.3 0-6.4.6-5.8 1.7-11.1 4.6-16.5 7.3-1.6.8-4 1.3-4.8-.2-.6-1.2.2-2.6 1.3-3.4C62.5 11 65 10.8 65.6 8c.4-1.9 0-4-1.4-5.3-2-2-5.3-2.3-8-1.2-2.5 1-4.6 3.2-6 5.7C48.8 9.6 48 12.3 47 15c-.3.9-.7 1.8-1.4 2.5-.7.6-2 .8-2.7.2-.6-.6-.6-1.5-.5-2.3 0-1.5-.2-3-1-4.2-2.8-4.9-8.9-2.8-10 1.2a10 10 0 000 5c.5 1.8 1 3.4 1 5.2-.1 2-1 4-3 4.7-1.4.4-3-.2-3.5-1.6-.7-1.8 1-3.5 1.4-5.3.5-2.4-1.3-5-3.7-5.6-2.5-.6-5 .5-6.7 2.4a11 11 0 00-2.3 7c0 2.4.5 4.9 1 7.3.4 1.3.7 2.8 0 4-.6 1-1.8 1.4-2.7.7-.8-.5-.7-1.7-1.2-2.6-.9-1.7-3.6-1.4-4.9.1-1.2 1.5-1.4 3.6-1.4 5.5l-.8 18v2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(413 239.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M2 2.7a6.4 6.4 0 00-2 4.5c0 3.6 2.8 6.5 6.4 6.6h.1A6.5 6.5 0 0013 7.4C13 4 10.2 1 6.6 1h-.1C4.8.9 3.2 1.5 2 2.7M6.4 12A4.6 4.6 0 012 7.3a4.6 4.6 0 014.6-4.5c2.6 0 4.7 2 4.6 4.6 0 1.2-.5 2.4-1.4 3.2-.8.8-2 1.3-3.2 1.3",
    mask: "url(#o)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#619440",
    d: "M390.2 215c-.1 3.2 2.4 6 5.8 6.1 3.3.2 6.2-2.2 6.4-5.3.2-3.2-2.4-6-5.7-6.1-3.4-.2-6.3 2.2-6.5 5.4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399 236.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M.7 4.9C.6 7.4 2.6 9.5 5.3 9.7c2.6.1 4.9-1.8 5-4.3A4.7 4.7 0 005.5.6 4.7 4.7 0 00.7 4.9",
    mask: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(344 161.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M3.5.1a3 3 0 00-3 3.2 3 3 0 003 3 3 3 0 003.1-3.1 3 3 0 00-3-3h-.1",
    mask: "url(#u)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M387.8 335.6c0 6.2-86.8 11.3-194 11.3-107 0-193.8-5-193.8-11.3 0-6.3 86.8-11.4 193.9-11.4 107 0 193.9 5.1 193.9 11.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M23.4 182.6h339.8v-12.2H23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M23.4 182.6h91v-12.2h-91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M115.8 182.6h-8l4.2 152.8h7.6l4-152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M112 335.4h3.8V185.9l-7.8 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M40.8 182.6h-8L37 335.4h7.6l4.1-152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M37 335.4h3.8V185.9l-7.8 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M345.7 182.6h-7.9l4.2 152.8h7.5l4.2-152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M342 335.4h3.7V185.9l-7.7 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M270.8 182.6h-8l4.2 152.8h7.5l4.2-152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M267 335.4h3.8V185.9l-7.8 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A2E35",
    d: "M184.7 105.1h-80.9c-2.9 0-4.7 2.4-4.1 5.3l10.7 51.4a6.9 6.9 0 006.4 5.2h80.8c3 0 4.8-2.3 4.2-5.2l-10.7-51.4a6.9 6.9 0 00-6.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M117.6 164.1c-2 0-4-1.7-4.4-3.6l-10.7-51.3c-.2-.8 0-1.5.4-2 .3-.5 1-.8 1.7-.8h80.8c2 0 4 1.7 4.3 3.6l10.8 51.4c.2.8 0 1.5-.4 2s-1 .7-1.7.7h-80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4DD",
    d: "M178.6 160l-10.2-48.6a2 2 0 011.9-2.4h13.1c1 0 1.8.6 2 1.5l10.1 48.7a2 2 0 01-1.9 2.4h-13.1a2 2 0 01-2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M109.2 113.2l-.4-2.1H125l.4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M116.7 118.4l-.5-2h28.4l.5 2zm1.5 5.3l-.5-2.2h31.9l.4 2.2zm1.5 5.2l-.5-2.1H145l.4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M114.1 137.4l-.4-2.1h10.2l.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M121.6 142.6l-.4-2h12.5l.4 2zm15.5 0l-.5-2h12.5l.5 2zm-14 5.3l-.4-2.2h42.2l.4 2.2zm1.5 5.2l-.4-2.1h32.1l.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A2E35",
    d: "M222.4 166.7H116c-2.9 0-4.7 1.7-4.1 3.7h116.9c-.6-2-3.5-3.7-6.4-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M110.5 42.7H93l-.4-1.8h17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M107.6 45.7h-7l-.3-1.9h7zm11.6 0h-10.7l-.4-1.9h10.7zm4.7 3h-22.6l-.4-1.9h22.6zm-2.9 3h-19l-.5-2h19.1zm12.7 31.6h-12.2l.4 1.8h12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M118.5 79.2h-17.8l-.4-1.9h17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M125.7 86.2H109l.4 1.9h16.6zm-5-3h-12.2l.4 2h12.2zm11.5-3H108l.4 2h24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M109.9 28.8H90.2l-.4-1.8h19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M119.5 36H98l.4 1.8h21.6zm-4.3-3h-18l.5 1.8h17.9zm1.2-3H96.7l.3 1.8h19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M109.6 56.5H96l-.4-1.9h13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M131 63.5h-26.6l.4 2h26.6zm-16.2-3h-11l.4 2h11zm12 0h-11l.3 2h11zm.7-2.9h-24.3l.3 1.9H128zm0 14.9h-21.2l.4 1.8h21.1zm-15.7-3h-6.2l.4 1.9h6.2zm9.6 0h-8.8l.4 1.9h8.8zm8-3H105l.4 1.9h24.3zm19-.5h-8.6l-.4-1.8h8.7zm14.6 0h-13.4l-.4-1.8h13.4zm5.7 3h-28.3l-.4-1.9h28.3zm-3.8 3H141l-.4-1.9h24zm10.7-17.8h-27l.3 1.9H176zm-5.2-3h-22.5l.4 1.9h22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M166.3 48.2h-24.7l.4 2h24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M176.9 83.9h-33.4l.4 1.8h33.3zm-20.2-3h-13.8l.4 1.9H157zm15 0h-13.8l.4 1.9H172zm1-3h-30.4l.3 1.9h30.5zm-.8 14.9h-26.5l.4 1.9h26.5zm-19.5-3h-7.7l.4 1.9h7.7zm12.1 0h-11l.4 1.9h11zm10-3h-30.4l.4 2H175zm-81 8.3H72.8L73 97H94zm-6.1-3H72l.4 1.9h15.2zm16.3 0H88.4l.4 1.9H104zm-1.7-3H71.5l.4 2h30.4zM334.8 151H322l1.5 19.4h9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M334.8 151H322l1.5 19.4h9.8zM55 137.5h18.5l-6.3 32.9H48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M78.5 128.7h-26l7.3 41.7h26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M51 128.7h1.5l7.3 41.7h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E38601",
    d: "M51 128.7h1.5l7.3 41.7h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M63.5 166L57.8 133h17l5.7 32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E38601",
    d: "M79.7 166L74 133h.8l5.7 32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57575E",
    d: "M207.7 75.3c.3.8.2 1.6-.3 1.9-.5.2-1.3-.2-1.6-1-.4-.8-.3-1.7.2-2s1.3.3 1.7 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M208 76.9s.3 5.5-.7 8.6c2 .7 4.2-1 4.2-1l-3.5-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57575E",
    d: "M207.8 68.7l-.3.1a4.1 4.1 0 00-3.3 1.8c-.2.3-.5.3-.7.2a.5.5 0 01-.2-.7s1.2-2.2 4.1-2.3a.5.5 0 01.4 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M237.1 74c3.1 10.8 6.5 19 10.8 23.8 0 0 0 8.4-14.3 12.4-15.8 4.4-9.7-5.7-9.7-5.7 8-4.4 7.2-11.2 1.2-13.7l12-16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57575E",
    d: "M251.2 95.8c-.3-4-.6-8.4-3-8.5-2.7-.1-18.1 6.7-21.4 11.6-3.3 4.8 3.1 9.6 3.1 9.6l21.3-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M219.7 156.3l-13.3-.4.2 11.1s11.6-1.2 12.1-4.2l1-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M199.3 161.4L198 167h8.6l-.2-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M273 110l-.2 2.9-.4 2.7a130 130 0 01-8.7 32.6c-.8 1.9-1.7 3.8-3 5.7-.2.5-.6 1-.9 1.4l-1 1.5-1.2 1.5-.7.7-.7.8a23 23 0 01-7 4.6 41 41 0 01-12.4 3.2 60 60 0 01-11.4.2 78.7 78.7 0 01-11-1.3l.3-10.5c6.4-1.3 13.1-2.6 18.9-4.5a39.7 39.7 0 007.2-3.3c.9-.6 1.4-1.2 1.5-1.4l.3-.5.4-.6.4-.7c0-.3.2-.5.3-.8 1-2.2 2.1-5 3-8l2.2-9.1 1.7-9.6.8-4.9.7-4.7 21 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E38601",
    d: "M273 110l-.2 2.9-.4 2.7a130 130 0 01-8.7 32.6c-.8 1.9-1.7 3.8-3 5.7-.2.5-.6 1-.9 1.4l-1 1.5-1.2 1.5-.7.7-.7.8a23 23 0 01-7 4.6 41 41 0 01-12.4 3.2 60 60 0 01-11.4.2 78.7 78.7 0 01-11-1.3l.3-10.5c6.4-1.3 13.1-2.6 18.9-4.5a39.7 39.7 0 007.2-3.3c.9-.6 1.4-1.2 1.5-1.4l.3-.5.4-.6.4-.7c0-.3.2-.5.3-.8 1-2.2 2.1-5 3-8l2.2-9.1 1.7-9.6.8-4.9.7-4.7 21 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M214 123.3c3.2 13.4 7.4 35.8 8.3 65.1H281c.3-7.2-.9-48-6.8-77.4a20.4 20.4 0 00-24.4-16h-.3a215 215 0 00-24 6.8h-.2a18.3 18.3 0 00-11.2 21.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E38601",
    d: "M217.8 142l1.4 9c4.8-5 6.3-20.4 6.3-20.4l-7.7 11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M169.2 157l-13.3-1.2-.4 11.1s6.8 2.3 12.3-3.5l1.4-6.4zm-19.6 2l-4.3 7.7 10.2.2.4-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF12",
    d: "M236 118.2a146.5 146.5 0 01-5.4 9.6 199.9 199.9 0 01-19.6 26.8 75.3 75.3 0 01-8.7 8.3l-1.3 1-1.5 1a20.7 20.7 0 01-3.5 2c-2.3 1-4.6 1.6-6.9 2a43.4 43.4 0 01-21.1-1.5c-1-.2-1.8-.5-2.9-1l1.7-10.2c6.2-.9 13-2 17.7-4.1 1.2-.5 2.2-1 3-1.7l.9-.8.6-.6.7-.7c2-2 4-4.3 6-6.7a194.5 194.5 0 0016.6-24.8l2.6-4.3 2.5-4.3 18.6 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M220 327h-11l-5.5-25.4h11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57575E",
    d: "M208.4 324.6h12.3c.4 0 .8.3.9.7l2.2 9.8c.2 1-.6 2-1.7 1.9-4.2 0-6.3-.3-11.7-.3-3.4 0-7.6.3-12.2.3-4.5 0-5.2-4.5-3.3-5 8.4-1.8 9-4.3 11.7-6.8.5-.4 1.1-.6 1.8-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M233.6 61.2c4 10.1 6.8 15.9 4.1 23.2-4 11-18.2 12.2-25 3.4-6.3-7.8-11.7-23-3.8-31.4a14.8 14.8 0 0124.7 4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57575E",
    d: "M214.4 76.4l-3 3.8s-3.3-8.3-2-12.2c-1.6-3.2-5 1.6-6.2-4.8-1.2-6.3 4.2-13 6.2-14.5.3.5.3 2.3.3 2.3s8-7.2 19.6-6.2c-.8.8-1.1 3-1.1 3s11.9 2 14.6 8.6c-1.8-.8-3-1-3-1s3.4 4.2 2.4 10.7a110 110 0 00-1.4 16.5c.1 2.9-7.7 8.3-12.4 2.5-4.8-5.8-14-8.7-14-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M219.3 74.2a11 11 0 01-.5 7.1c-1.2 3-3.8 2.3-5.1-.3-1.2-2.4-2-6.8.1-8.8 2-2.1 4.7-.8 5.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M239.9 188.4S189 207 187.6 231.2c-2.8 45 15.6 80.5 15.6 80.5L220 310s-3-14.4-5.2-55.1c-2.8-51.2 84 1.2 66.1-66.4h-41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M239.9 188.4S189 207 187.6 231.2c-2.8 45 15.6 80.5 15.6 80.5L220 310s-3-14.4-5.2-55.1c-2.8-51.2 84 1.2 66.1-66.4h-41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M198.5 305.5l2.7 7.5 21-2-1-6.8-22.7 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC581",
    d: "M172.6 328.2h-11l-3.1-25.4h11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57575E",
    d: "M161.6 324.6h12c.4 0 .8.3.9.7l2.1 9.7c.3 1-.5 2-1.5 2-4.3 0-10.6-.3-16-.3-6.3 0-7.5.3-15 .3-4.5 0-5.7-4.5-3.8-5 8.5-1.8 11.3-2 18.6-6.6a5 5 0 012.7-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E8C8",
    d: "M222.3 188.4s-83.3 7.4-82.4 49.2c1 43.6 17.2 73 17.2 73h16.3s-3-22.7-2.5-65.5c.1-12.8 26-17 51.4-18.6a58.2 58.2 0 0050.8-34l1.8-4h-52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M222.3 188.4s-83.3 7.4-82.4 49.2c1 43.6 17.2 73 17.2 73h16.3s-3-22.7-2.5-65.5c.1-12.8 26-17 51.4-18.6a58.2 58.2 0 0050.8-34l1.8-4h-52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M153.3 306.1l2.8 7.6 19.6-1.4-1.1-6.8-21.3.6zm91-164.7l-10.7 40.7c-2.7 10.4-4 21.2-4 32v19c0 4.7 3.5 8.6 7.8 8.6h54.2c4.4 0 7.9-4 7.9-8.7v-19c0-10.7 1.4-21.5 4-31.9l9.4-36c1.4-5.5-2.3-11-7.6-11h-53.5a8 8 0 00-7.6 6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M176.8 222l1.8 10c1 5.4 5.6 9.7 10.4 9.7h60.3c4.8 0 8-4.3 7-9.7l-1.8-10c-1-6.1-6.3-11-11.8-11h-57.8c-5.5 0-9.1 4.9-8 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M255 251.8h-31.5l-3-10.1H258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M233.6 327.2H245v-75.4h-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A29C8F",
    d: "M245 327.2h-11.4v-73.6l11.3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M242.2 327.2h-2.7v-73l2.7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F786A",
    d: "M265.2 338.9h-51.8c-1.4 0-2-1.8-.9-2.6l8.2-6a23 23 0 0113.7-4.5h9.8a23 23 0 0113.6 4.4l8.2 6c1.2.9.6 2.7-.8 2.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterImg3);
export default __webpack_public_path__ + "static/media/registerImg3.0e44833055a6c0232bc571c630cc5f4d.svg";
export { ForwardRef as ReactComponent };